<div>
  <div class="text-xs mb-10 space-y-2">
    <p>Utilize o formulário abaixo para fazer a alteração dos seus dados pessoais.</p>
    <p class="text-amber-800">Nota: Ao realizar a alteração da palavra-chave, a sessão do usuário será expirada em todos
      os outros disposivos.</p>
  </div>


  <form method="POST" class="space-y-4" [formGroup]="form" (ngSubmit)="onSubmit()">

    <div class="space-y-8">
      <!-- current Passowrd-->
      <div>
        <app-text-input [formGroup]="form" id="current" [maxLength]="100" type="password"
                        placeholder="Palavra-chave Actual" label="Palavra-chave Actual"
                        [value]="form.value?.current" [formError]="formErrors.get('current')"
        ></app-text-input>
      </div>

      <!-- password-->
      <div>
        <app-text-input [formGroup]="form" id="password" [maxLength]="100" type="password"
                        placeholder="Palavra-chave" label="Palavra-chave"
                        [value]="form.value?.password" [formError]="formErrors.get('password')"
        ></app-text-input>
      </div>

      <!--password repeat-->
      <div>
        <app-text-input [formGroup]="form" id="passwordRepeat" [maxLength]="100" type="password"
                        placeholder="Repita a palavra-chave" label="Repita a palavra-chave"
                        [value]="form.value?.passwordRepeat" [formError]="formErrors.get('passwordRepeat')"
        ></app-text-input>
      </div>
    </div>

    <!-- submit button -->
    <div class="flex justify-end">
      <app-ae-button variant="primary" label="Alterar palavra-passe" [disabled]="!form.valid" [loading]="isLoading"
                (buttonClick)="onSubmit()" size="sm"></app-ae-button>
    </div>
  </form>
</div>
